import firebase from "firebase";
import { firebaseConfig } from "../configs/firebaseConfig";

export default class FirebaseService {
  static initialize = () => {
    firebase.initializeApp(firebaseConfig);
  };
}
